<div id="background"></div>
<ng-container *ngIf="initialize">
  <header class="header">
    <h1 style="margin-left: 12px;">
      <img
        class="logo-image"
        [src]="logoUrl1"
        width="110"
        height="20"
        style="margin-bottom: 8px;"
        alt="SgzpMaster"
      />
      <img
        class="logo-image"
        [src]="logoUrl2"
        width="194"
        height="20"
        alt="SgzpMaster"
      />
    </h1>
  </header>

  <div class="container isBackgoround">
    <main>
      <div class="v-application v-application--is-ltr theme--light main">
        <img
          src="/assets/sgzp-app4/images/unblock.svg"
          width="100"
          height="100"
          alt="SGマスタ"
        />
        <h2 class="text-h6 font-weight-bold text-center mb-6">
          ロックを解除しました
        </h2>
        <p class="text-caption text-subtitle-1 text-center mb-6">
          あなたのアカウントのロックが解除されました。<br />
          {{ countdown }}秒後にログインページに自動的に移動します。
        </p>
        <p class="text-caption text-center mb-6">
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>

        <div class="mb-6">
          <button (click)="redirect()" class="resetButton font-weight-bold">
            トップに戻る
          </button>
        </div>
      </div>
    </main>
  </div>
</ng-container>
